/**
 * BillingPager — shared footer pager for the Patient Billing sub-tab lists.
 * Page-size selector (Flutter 10/25/50/100) + prev/next + count, matching
 * `CustomTableListWidget`'s paging options.
 */

import { Button, Select } from '@scripsteam/scrips-signal-ds';

export const BILLING_PAGE_SIZES = [10, 25, 50, 100];

interface BillingPagerProps {
  page: number;
  totalPages: number;
  totalRecords: number;
  pageSize: number;
  isFetching: boolean;
  /** Plural noun for the empty count, e.g. "invoices" / "receipts". */
  noun: string;
  onPage: (next: number) => void;
  onPageSize: (next: number) => void;
}

export function BillingPager({
  page,
  totalPages,
  totalRecords,
  pageSize,
  isFetching,
  noun,
  onPage,
  onPageSize,
}: BillingPagerProps) {
  return (
    <div className="flex items-center justify-between text-sm text-text-muted">
      <div className="flex items-center gap-2">
        <span>Rows per page</span>
        <Select
          value={String(pageSize)}
          onChange={(v) => onPageSize(Number(v))}
          size="compact"
          className="w-18"
          options={BILLING_PAGE_SIZES.map((n) => ({
            label: String(n),
            value: String(n),
          }))}
        />
      </div>
      <div className="flex items-center gap-3">
        <span>
          {totalRecords > 0
            ? `Page ${page} of ${totalPages} (${totalRecords} total)`
            : `No ${noun}`}
        </span>
        <div className="flex items-center gap-2">
          <Button
            type="button"
            variant="secondary"
            size="sm"
            onClick={() => onPage(Math.max(1, page - 1))}
            disabled={page <= 1 || isFetching}
          >
            Previous
          </Button>
          <Button
            type="button"
            variant="secondary"
            size="sm"
            onClick={() => onPage(page + 1)}
            disabled={page >= totalPages || isFetching}
          >
            Next
          </Button>
        </div>
      </div>
    </div>
  );
}
